import { css } from '@emotion/react'
import { fonts, fontSizes, fontWeights } from '@opallabs/pulsar'
import { redditColors } from '../../styles/colors'

export const headerWrapper = css({
  display: 'flex',
  alignItems: 'center',
  padding: '8px 0',
  gap: '8px',
})

export const headerInfo = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  flex: 1,
  minWidth: 0,
})

export const usernameRow = css({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
})

export const username = css({
  fontFamily: fonts.helvetica,
  fontSize: fontSizes.medium,
  fontWeight: fontWeights.bold,
  color: redditColors.darkText,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
})

export const promotedBadge = css({
  fontFamily: fonts.helvetica,
  fontSize: '11px',
  fontWeight: fontWeights.normal,
  color: redditColors.iconGray,
  backgroundColor: 'transparent',
  padding: '0',
  marginLeft: '4px',
})

export const dotSeparator = css({
  color: redditColors.secondaryText,
  fontSize: '11px',
})
